/**
 * Shared route configuration for the Creative system
 * Centralizes all route validation logic and tab definitions
 */
export const CREATIVE_ROUTE_CONFIG = {
  validTabs: ['displayAds', 'videoAds'],
  validSubtabs: {
    displayAds: ['displayAdsUnits', 'adGroups'],
    videoAds: ['videos', 'adVideoGroups']
  },
  defaultRoute: {
    tab: 'displayAds',
    subtab: 'displayAdsUnits',
    page: 1
  }
};

/**
 * Helper function to check if a tab is valid
 */
export const isValidTab = (tab) => {
  return CREATIVE_ROUTE_CONFIG.validTabs.includes(tab);
};

/**
 * Helper function to check if a subtab is valid for a given tab
 */
export const isValidSubtab = (tab, subtab) => {
  return CREATIVE_ROUTE_CONFIG.validSubtabs[tab]?.includes(subtab) || false;
};

/**
 * Helper function to check if a page number is valid
 */
export const isValidPageNumber = (pageNumber) => {
  return !isNaN(pageNumber) && pageNumber > 0;
};

/**
 * Complete route validation
 */
export const validateRouteParameters = (tab, subtab, pageNumber) => {
  return {
    isValidTab: isValidTab(tab),
    isValidSubtab: isValidSubtab(tab, subtab),
    isValidPage: isValidPageNumber(pageNumber),
    isValid: isValidTab(tab) && isValidSubtab(tab, subtab) && isValidPageNumber(pageNumber)
  };
};